import { Component, Input } from '@angular/core';
import "@radiance-design-software/menu";
import "@radiance-design-software/menu-item";
import "@radiance-design-software/button";
import { ActivatedRoute, Router } from '@angular/router';
import { forEach } from 'lodash';
import { RadianceTabUtilities, RadTabItem } from '@app/core/utilities/radiance-tab.utilities';

@Component({
  selector: 'app-tabs-page',
  templateUrl: './tabs-page-layout.component.html',
  styleUrls: ['./tabs-page-layout.component.scss']
})
export class TabsPageLayoutComponent {
  @Input() pageHeader: string = "";
  @Input() menuItems: RadTabItem[] = [];
  @Input() activateFn: (component: any) => void = () => { };

  public isTabsLoaded = false

  constructor(
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  ngAfterViewInit() {
    this.isTabsLoaded = true;
    this.updateSelectedTabs();
  }

  onActivate(component: any) {
    this.activateFn(component);
    this.updateSelectedTabs();
  }

  onTabClicked($event) {
    RadianceTabUtilities.handleTabClick($event, this.menuItems, this.router, this.route);
  }

  private updateSelectedTabs() {
    forEach(this.menuItems, (menuItem) => {
      menuItem.selected = false;
      if (this.router.url.includes(menuItem.route[0] as string)) {
        menuItem.selected = true;
      }
    });
  }
}
